export default function anonymous(it
) {
var out='<section class="document-meta '+(it.showClass)+'" id="provider-card"> <i class="new-logo icon-source '+(it.className)+'" id="provider-icon"></i> <span class="source-txt" id="provider-title">'+(it.sourceName)+'</span></section>';return out;
}